import _classCallCheck from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
import { EventType, PlatformEvent } from "./PlatformEvent";
export var ServiceEvent = /*#__PURE__*/function (_PlatformEvent) {
  _inherits(ServiceEvent, _PlatformEvent);

  var _super = _createSuper(ServiceEvent);

  function ServiceEvent(eventName, jsonstring) {
    var _this;

    var eventType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EventType.Info;

    _classCallCheck(this, ServiceEvent);

    _this = _super.call(this, eventName, eventType);
    _this.privJsonResult = jsonstring;
    return _this;
  }

  _createClass(ServiceEvent, [{
    key: "jsonString",
    get: function get() {
      return this.privJsonResult;
    }
  }]);

  return ServiceEvent;
}(PlatformEvent);
export var ConnectionEvent = /*#__PURE__*/function (_PlatformEvent2) {
  _inherits(ConnectionEvent, _PlatformEvent2);

  var _super2 = _createSuper(ConnectionEvent);

  function ConnectionEvent(eventName, connectionId) {
    var _this2;

    var eventType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EventType.Info;

    _classCallCheck(this, ConnectionEvent);

    _this2 = _super2.call(this, eventName, eventType);
    _this2.privConnectionId = connectionId;
    return _this2;
  }

  _createClass(ConnectionEvent, [{
    key: "connectionId",
    get: function get() {
      return this.privConnectionId;
    }
  }]);

  return ConnectionEvent;
}(PlatformEvent);
export var ConnectionStartEvent = /*#__PURE__*/function (_ConnectionEvent) {
  _inherits(ConnectionStartEvent, _ConnectionEvent);

  var _super3 = _createSuper(ConnectionStartEvent);

  function ConnectionStartEvent(connectionId, uri, headers) {
    var _this3;

    _classCallCheck(this, ConnectionStartEvent);

    _this3 = _super3.call(this, "ConnectionStartEvent", connectionId);
    _this3.privUri = uri;
    _this3.privHeaders = headers;
    return _this3;
  }

  _createClass(ConnectionStartEvent, [{
    key: "uri",
    get: function get() {
      return this.privUri;
    }
  }, {
    key: "headers",
    get: function get() {
      return this.privHeaders;
    }
  }]);

  return ConnectionStartEvent;
}(ConnectionEvent);
export var ConnectionEstablishedEvent = /*#__PURE__*/function (_ConnectionEvent2) {
  _inherits(ConnectionEstablishedEvent, _ConnectionEvent2);

  var _super4 = _createSuper(ConnectionEstablishedEvent);

  function ConnectionEstablishedEvent(connectionId, metadata) {
    _classCallCheck(this, ConnectionEstablishedEvent);

    return _super4.call(this, "ConnectionEstablishedEvent", connectionId);
  }

  return ConnectionEstablishedEvent;
}(ConnectionEvent);
export var ConnectionClosedEvent = /*#__PURE__*/function (_ConnectionEvent3) {
  _inherits(ConnectionClosedEvent, _ConnectionEvent3);

  var _super5 = _createSuper(ConnectionClosedEvent);

  function ConnectionClosedEvent(connectionId, statusCode, reason) {
    var _this4;

    _classCallCheck(this, ConnectionClosedEvent);

    _this4 = _super5.call(this, "ConnectionClosedEvent", connectionId, EventType.Debug);
    _this4.privReason = reason;
    _this4.privStatusCode = statusCode;
    return _this4;
  }

  _createClass(ConnectionClosedEvent, [{
    key: "reason",
    get: function get() {
      return this.privReason;
    }
  }, {
    key: "statusCode",
    get: function get() {
      return this.privStatusCode;
    }
  }]);

  return ConnectionClosedEvent;
}(ConnectionEvent);
export var ConnectionErrorEvent = /*#__PURE__*/function (_ConnectionEvent4) {
  _inherits(ConnectionErrorEvent, _ConnectionEvent4);

  var _super6 = _createSuper(ConnectionErrorEvent);

  function ConnectionErrorEvent(connectionId, message, type) {
    var _this5;

    _classCallCheck(this, ConnectionErrorEvent);

    _this5 = _super6.call(this, "ConnectionErrorEvent", connectionId, EventType.Debug);
    _this5.privMessage = message;
    _this5.privType = type;
    return _this5;
  }

  _createClass(ConnectionErrorEvent, [{
    key: "message",
    get: function get() {
      return this.privMessage;
    }
  }, {
    key: "type",
    get: function get() {
      return this.privType;
    }
  }]);

  return ConnectionErrorEvent;
}(ConnectionEvent);
export var ConnectionEstablishErrorEvent = /*#__PURE__*/function (_ConnectionEvent5) {
  _inherits(ConnectionEstablishErrorEvent, _ConnectionEvent5);

  var _super7 = _createSuper(ConnectionEstablishErrorEvent);

  function ConnectionEstablishErrorEvent(connectionId, statuscode, reason) {
    var _this6;

    _classCallCheck(this, ConnectionEstablishErrorEvent);

    _this6 = _super7.call(this, "ConnectionEstablishErrorEvent", connectionId, EventType.Error);
    _this6.privStatusCode = statuscode;
    _this6.privReason = reason;
    return _this6;
  }

  _createClass(ConnectionEstablishErrorEvent, [{
    key: "reason",
    get: function get() {
      return this.privReason;
    }
  }, {
    key: "statusCode",
    get: function get() {
      return this.privStatusCode;
    }
  }]);

  return ConnectionEstablishErrorEvent;
}(ConnectionEvent);
export var ConnectionMessageReceivedEvent = /*#__PURE__*/function (_ConnectionEvent6) {
  _inherits(ConnectionMessageReceivedEvent, _ConnectionEvent6);

  var _super8 = _createSuper(ConnectionMessageReceivedEvent);

  function ConnectionMessageReceivedEvent(connectionId, networkReceivedTimeISO, message) {
    var _this7;

    _classCallCheck(this, ConnectionMessageReceivedEvent);

    _this7 = _super8.call(this, "ConnectionMessageReceivedEvent", connectionId);
    _this7.privNetworkReceivedTime = networkReceivedTimeISO;
    _this7.privMessage = message;
    return _this7;
  }

  _createClass(ConnectionMessageReceivedEvent, [{
    key: "networkReceivedTime",
    get: function get() {
      return this.privNetworkReceivedTime;
    }
  }, {
    key: "message",
    get: function get() {
      return this.privMessage;
    }
  }]);

  return ConnectionMessageReceivedEvent;
}(ConnectionEvent);
export var ConnectionMessageSentEvent = /*#__PURE__*/function (_ConnectionEvent7) {
  _inherits(ConnectionMessageSentEvent, _ConnectionEvent7);

  var _super9 = _createSuper(ConnectionMessageSentEvent);

  function ConnectionMessageSentEvent(connectionId, networkSentTimeISO, message) {
    var _this8;

    _classCallCheck(this, ConnectionMessageSentEvent);

    _this8 = _super9.call(this, "ConnectionMessageSentEvent", connectionId);
    _this8.privNetworkSentTime = networkSentTimeISO;
    _this8.privMessage = message;
    return _this8;
  }

  _createClass(ConnectionMessageSentEvent, [{
    key: "networkSentTime",
    get: function get() {
      return this.privNetworkSentTime;
    }
  }, {
    key: "message",
    get: function get() {
      return this.privMessage;
    }
  }]);

  return ConnectionMessageSentEvent;
}(ConnectionEvent);